import { InvoiceTaskSubscription } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1870. 請求タスク購読
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_subscriptions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const createInvoiceTaskSubscription = (props: Props): Promise<InvoiceTaskSubscription> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_subscriptions`,
    props
  );
};

export const useCreateInvoiceTaskSubscription = () => {
  return useMutation({
    mutationFn: createInvoiceTaskSubscription
  });
};
